import request from './plugins/request'

// 登录
export let login = (params = {}) => {
  return request({
    url: '/user/login',
    params: params,
    method: 'post'
  })
}
